import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Header } from './Header';
import { VideoListing } from './VideoListing';
import { Loader } from '../../../../../../common/react/components/Loader';
import { navSelector } from '../../../../store/js/modules/competition-nav/selectors/nav-selector';
import { viewByMatchSelector } from '../../../../store/js/modules/video-hub/view-by-match/selectors';
import { getTranslation } from '../../../../../../common/react/utils/translations';

import { Pill } from './Pill';

let links = [
    {
        filter: 'ProgramCategory:Match Highlights',
        label: getTranslation('label.match.highlights')
    },
    {
        filter: 'ProgramCategory:Mini-Matches',
        label: getTranslation('label.match.mini.matches')
    },
    {
        filter: 'ProgramCategory:Match Replays',
        label: getTranslation('label.match.fullReplays')
    },
    {
        filter: 'ProgramCategory:Press Conference',
        label: getTranslation('label.match.press.conference')
    }
];

const findFilterInLinks = (filter) =>
    links.findIndex((link) => link.filter === filter);

export const VideoListContainer = ({ defaultFilter, defaultFilterText }) => {
    const defaultIndex = findFilterInLinks(defaultFilter);
    const [visibleFilters, setVisibleFilters] = useState([]);

    if (defaultFilter && defaultIndex !== -1) {
        if (
            defaultFilterText &&
            links[defaultIndex].label !== defaultFilterText
        ) {
            links[defaultIndex].label = defaultFilterText;
        }
    } else if (defaultFilter) {
        links.unshift({
            filter: defaultFilter,
            label: defaultFilterText || defaultFilter
        });
    }

    const [activeFilter, setActiveFilter] = useState(
        findFilterInLinks(defaultFilter)
    );

    const nav = useSelector(navSelector);
    const matchID = useSelector(viewByMatchSelector)?.matchId;
    const round = nav?.round;
    const matchesData = useSelector(
        (state) =>
            PULSE.app.redux.selectors.matchList.item(
                state,
                nav.competition?.id,
                nav.season?.id,
                nav.round?.roundNumber
            ) ?? []
    );

    const [matchData, setMatchData] = useState({});

    // if default has results we can render,
    // set the activeFilter to be default
    useEffect(() => {
        if (
            defaultFilter &&
            visibleFilters.includes(findFilterInLinks(defaultFilter))
        ) {
            setActiveFilter(findFilterInLinks(defaultFilter));
        } else if (
            !visibleFilters.includes(activeFilter) &&
            visibleFilters.length
        ) {
            // if default doesn't have results we can set to a tag with results
            setActiveFilter(visibleFilters[0]);
        }
    }, [nav, visibleFilters]);

    useEffect(() => {
        const match = matchesData.find((obj) => obj.id === matchID);
        if (match) {
            setMatchData(match);
        }
    }, [matchesData, matchID]);

    return (
        <div className="media-list media-list--video video-hub-video-listing">
            <div className="wrapper">
                {round.name && (
                    <Header
                        roundName={round.name}
                        matchData={matchData}
                        matchID={matchID}
                    />
                )}

                {!nav.season?.id || !nav.round.id ? (
                    <Loader />
                ) : (
                    <>
                        {!matchID && (
                            <ul className="video-list__filters video-hub-video-listing__filters js-video-filters">
                                {links.map((link, index) => (
                                    <Pill
                                        link={link}
                                        index={index}
                                        key={index}
                                        updateActiveFilterHandler={
                                            setActiveFilter
                                        }
                                        activeFilter={activeFilter}
                                        seasonId={nav.season?.id}
                                        roundId={nav.round.id}
                                        matchID={matchID}
                                        setVisibleFilters={setVisibleFilters}
                                    />
                                ))}
                            </ul>
                        )}

                        <VideoListing
                            seasonId={nav.season?.id}
                            roundId={nav.round.id}
                            matchID={matchID}
                            tagName={
                                links[activeFilter]
                                    ? links[activeFilter].filter
                                    : ''
                            }
                        />
                    </>
                )}
            </div>
        </div>
    );
};

VideoListContainer.propTypes = {
    defaultFilter: PropTypes.string,
    defaultFilterText: PropTypes.string
};
